import React, {Component} from 'react';

import PieChart from './PieChart.js';


const pieData = [
    {
        "id": "year_1",
        "label": "1년차",
        "value": 3371
    },
    {
        "id": "year_2",
        "label": "2년차",
        "value": 2479
    },
    {
        "id": "year_3",
        "label": "3년차",
        "value": 1745
    },
    {
        "id": "year_4",
        "label": "4년차",
        "value": 347
    }
];

class NurseryTypePie extends Component {

    constructor(props) {
        super(props);

        this.state = {
            nurseryList : this.props.nurseryList,
            pieData : null
        }
    }

    componentDidMount(){    
        this.buildTableData();
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            nurseryList : nextProps.nurseryList
        }, () => this.buildTableData() );
    }

    buildTableData = () => {
        var pieData = [];
        if(this.state.nurseryList) {
            var daycare = 0;
            var kinder = 0;
            var unknown = 0;

            this.state.nurseryList.forEach(nursery => {
                switch (nursery.type) {
                    case '유치원' : kinder += nursery.data.total; 
                        break;
                    case '어린이집' : daycare+= nursery.data.total; 
                        break;
                    default : unknown += nursery.data.total;
                        break;
                }
            });

            pieData = [
                {
                    "id" : "kinder",
                    "name" : "유치원",
                    "value" : kinder
                },
                {
                    "id" : "daycare",
                    "name" : "어린이집",
                    "value" : daycare
                },
                {
                    "id" : "unknown",
                    "name" : "기타",
                    "value" : unknown
                }
            ];
        }

        this.setState({
            pieData : pieData
        });
    }





	render() {
            if (this.state.nurseryList != null && this.state.pieData != null && this.state.pieData.length > 0) {
                return (
                    <div className="card border-top border-3 border-info">
                        <div className="card-header d-flex" style={{ padding: "5px 20px"}}>
                            <h5 className="card-header-title">분류</h5>
                        </div>
                        <div className="card-body" style={{height:this.props.height + "px"}} >
                            <PieChart data={this.state.pieData}/>
                        </div>
                    </div>
                )
            } else if(this.state.pieData != null && this.state.pieData.length == 0) {
                return (
                    <div className="card border-top border-3 border-top-primary">
                        <div className="card-header d-flex" style={{ padding: "5px 20px"}}>
                            <h5 className="card-header-title">분류</h5>
                        </div>
                        <div className="card-body" style={{height:this.props.height + "px", textAlign:"center", paddingTop:"100px"}}>
                            No Data
                        </div>
                    </div>
                )
            } else {
                return(
                    <div className="card border-top border-3 border-top-primary">
                        <div className="card-header d-flex" style={{ padding: "5px 20px"}}>
                            <h5 className="card-header-title">분류</h5>
                        </div>
                        <div className="card-body" style={{height:this.props.height + "px", textAlign:"center", paddingTop:"100px"}}>
                            <span className="dashboard-spinner spinner-xxl"></span>
                        </div>
                    </div>
                )
            }

	}

}


export default NurseryTypePie;